export default "__VITE_ASSET__66b46392__"